export default __webpack_public_path__ + "static/media/laudo4.704bd694.jpg";